
<div
  class="rfp-rr-rating-snapshot-150-or rr-rating-snapshot float-left"
  :class="{ 'rfp-rr-rating-rtl': isRightToLeftActive }"
>
  <div class="rfp-rr-rating-snapshot-151-or rr-rating-snapshot-inner">
    <h3 class="rfp-rr-rating-snapshot-152-or rr-sub-title black">{{ headerTitle }}</h3>
    <p>{{ headerSubTitle }}</p>
    <ul>
      <li v-for="x in sortArrays(ratingBar)" :key="x.label" class="rfp-rr-rating-snapshot-153-or">
        <span class="rfp-rr-rating-snapshot-154-or" style="width: 30px; display: inline-block"
          >{{ x.label
          }}<span class="rfp-rr-rating-snapshot-star-157-or">{{ starIcon }}</span></span
        >
        <span
          class="rfp-rr-rating-snapshot-155-or rr-rating-bar-outer"
          @click="filterStars(x.label)"
        >
          <span
            class="rfp-rr-rating-snapshot-156-or rr-rating-bar-inner"
            :class="{ Enabled: x.count != 0 }"
            :style="{ width: x.Average }"
          ></span> </span
        >{{ x.count }}
      </li>
    </ul>
  </div>
</div>
